import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const BulkExport = (props: SvgIconProps) => (
  <SvgIcon {...props} width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M31.7574 5.52942C34.1005 3.1864 37.8995 3.1864 40.2426 5.52942L55.0919 20.3787C56.2635 21.5502 56.2635 23.4498 55.0919 24.6215C53.9203 25.793 52.0208 25.793 50.8493 24.6215L39 12.7722V36C39 37.6569 37.6569 39 36 39C34.3431 39 33 37.6569 33 36V12.7722L21.1507 24.6215C19.9792 25.793 18.0797 25.793 16.9081 24.6215C15.7365 23.4498 15.7365 21.5502 16.9081 20.3787L31.7574 5.52942Z"
      fill="white"
    />
    <path
      d="M15 51.0079C15 49.351 13.6569 48.0079 12 48.0079C10.3431 48.0079 9 49.351 9 51.0079V57.0079C9 60.3216 11.6863 63.0079 15 63.0079H57C60.3137 63.0079 63 60.3216 63 57.0079V51.0079C63 49.351 61.6568 48.0079 60 48.0079C58.3431 48.0079 57 49.351 57 51.0079V57.0079H15V51.0079Z"
      fill="white"
    />
    <path
      d="M36 45.0079C34.3431 45.0079 33 46.351 33 48.0079C33 49.6648 34.3431 51.0079 36 51.0079C37.6569 51.0079 39 49.6648 39 48.0079C39 46.351 37.6569 45.0079 36 45.0079Z"
      fill="white"
    />
  </SvgIcon>
);
BulkExport.displayName = "SlideIcon";
BulkExport.muiName = "SvgIcon";

export default pure(BulkExport);
